// neutral tier: app-specific, theme-agnostic component. Extends the base
// component directly (5 dirs up to the webapp root, then into core/themes/base) —
// the same target metronic's empty component/component.js passthrough resolved to.
const component = require('../../../../../core/themes/base/components/component/component');

const productAvailabilityLabel = Object.assign({}, component, {
    productComponent: false,
    clientComponent: false,
    enabledClasses: [],
    disabledClasses: [],

    inited: function () {
        component.inited.call(this);

        // The base 'alert' decoration is applied via the component cssZone at
        // render time (config.json). The enabled/disabled state classes are
        // resolved here from the active theme's cssClassesMap (exposed in JS via
        // hm.app.cssClass — the same map PHP transcribes with) and toggled at
        // runtime in check(). Split so multi-class theme values work with classList.
        this.enabledClasses = this.hm.app.cssClass('alertSuccess').split(' ').filter(Boolean);

        this.disabledClasses = this.hm.app.cssClass('alertWarning').split(' ').filter(Boolean);

        let productComponentId = this.extraAttributes.productIdComponent;

        let clientComponentId = this.extraAttributes.clientIdComponent;

        this.productComponent = this.hm.app.components[productComponentId];
        this.clientComponent = this.hm.app.components[clientComponentId];

        this.check();

        this.productComponent.element.addEventListener('change', (e) => {
            this.check();
        });

        this.clientComponent.element.addEventListener('change', (e) => {
            this.check();
        });
    },

    check: async function () {
        let data = {
            configHash: this.configHash,
            componentAction: 'checkProductAvailability',
            productId: this.productComponent.getValue(),
            clientId: this.clientComponent.getValue()
        };

        let response = await this.hm.app.fetchJson('components', 'main', data);

        let enabled = parseInt(response.enabled);

        if (enabled) {
            if (this.disabledClasses.length) {
                this.element.classList.remove(...this.disabledClasses);
            }

            if (this.enabledClasses.length) {
                this.element.classList.add(...this.enabledClasses);
            }

            this.element.innerHTML = this.hm.app.utext('productIsEnabledInClientsMarketplace');
        } else {
            if (this.enabledClasses.length) {
                this.element.classList.remove(...this.enabledClasses);
            }

            if (this.disabledClasses.length) {
                this.element.classList.add(...this.disabledClasses);
            }

            this.element.innerHTML = this.hm.app.utext('productIsNotEnabledInClientsMarketplace');
        }
    }
});

module.exports = productAvailabilityLabel;
